import { render, staticRenderFns } from "./recipe-feedback.vue?vue&type=template&id=09dfd286&scoped=true&"
import script from "./recipe-feedback.vue?vue&type=script&lang=js&"
export * from "./recipe-feedback.vue?vue&type=script&lang=js&"
import style0 from "./recipe-feedback.vue?vue&type=style&index=0&id=09dfd286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfd286",
  null
  
)

export default component.exports